import * as _ from 'lodash';
import contract from '../../../services/contracts'
import sales from '../../../services/sales'
import Payment from '../../common/adhesion/payment';
import * as utils from '../../../utils.js'
import Financial from '../../../services/financial';
import Auth from '../../../services/auth';

export default {
  props: ['contractId','payment', 'planId', 'addressMailing', 'creditCardOptions', 'bankAccountOptions', 'bankBillOption', 'value', 'showNewPayment'],
  data() {
    return {
      arrayDebito: undefined,
      arrayCartao: undefined,
      boletoCadastrato: undefined,
      boleto: undefined,
      index: 1,
      contractPaymentMethodId: this.value,
      loading:undefined,
      paymentSelected: this.payment,
      paymentMethodsAuthorized: {}

    }
  },
  mounted: function () {
    if (this.taxIdNumber) {
      Financial.getPaymentMethodUnauthorized(this.taxIdNumber).then(authResponse => {
        const authMethods = authResponse.data.data.paymentMethods;

        this.paymentMethodsAuthorized = {};

        // Lógica: authorized: 1 = PODE usar (true), authorized: 0 = NÃO pode usar (false)
        authMethods.forEach(method => {
          this.paymentMethodsAuthorized[method.shortName] = method.authorized === 1;
        });

        if(this.planId){
          this.load();
        }
      }).catch(error => {
        console.error('Erro ao buscar autorizações:', error);
        if(this.planId){
          this.load();
        }
      });
    } else {
      if(this.planId){
        this.load();
      }
    }
  },
  watch:{
    contractPaymentMethodId(newValue){
      this.$emit('input', newValue);
    },
    planId(){
      this.load();
    }
  },
  methods: {
    load(){
      this.loading = contract.getPaymentMethod(this.contractId).then(result => {
        let data = result;

        // Filtrar métodos de pagamento baseado nas autorizações (se já foram carregadas)
        if (this.taxIdNumber && Object.keys(this.paymentMethodsAuthorized).length > 0) {
          data = data.filter(item => {
            const shortName = item.paymentMethod.paymentShortName;
            if (shortName && this.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
              // Retorna true se authorized === 1 (pode usar), false se authorized === 0 (não pode usar)
              return this.paymentMethodsAuthorized[shortName];
            }
            return true;
          });
        }

        //seleciona conta corrente
        if(this.planId == 28){
          this.paymentSelected =  _.filter(data, {type: 'CR'})[0];
          
          if(!this.paymentSelected) {
            this.paymentSelected = data[0];
          }
          this.contractPaymentMethodId = this.paymentSelected.contractPaymentMethodId;

        } else {
          this.arrayCartao = _.filter(data, function(o){return o.paymentMethod.paymentShortName == 'CC'});
          this.arrayDebito = _.filter(data, function(o){return o.paymentMethod.paymentShortName == 'DC'});
          this.boletoCadastrato = _.filter(data, function(o){return o.paymentMethod.paymentShortName == 'BC'});
          if(this.boletoCadastrato.length > 0){
            this.boletoCadastrato = this.boletoCadastrato[0];
          }
        }

        if(!this.contractPaymentMethodId || this.contractPaymentMethodId==-1){
          
          
          if(this.arrayCartao && this.arrayCartao.length > 0){
            this.contractPaymentMethodId = this.arrayCartao[0].contractPaymentMethodId;
            this.paymentSelected = this.arrayCartao[0];
          }
          else if(this.arrayDebito && this.arrayDebito.length > 0){
            this.contractPaymentMethodId = this.arrayDebito[0].contractPaymentMethodId;
            this.paymentSelected = this.arrayDebito[0];
          }
          else if(this.boletoCadastrato){
            this.contractPaymentMethodId = this.boletoCadastrato.contractPaymentMethodId;
            this.paymentSelected = this.boletoCadastrato;
          }

          if(!this.boletoCadastrato || this.boletoCadastrato.length == 0 ){
            this.boletoCadastrato = {contractPaymentMethodId: -1, paymentMethod: {paymentMethodId: 12}};
            this.paymentSelected = this.boletoCadastrato;
          }

          this.validateAll();
        }

      });

      this.$store.commit('currentPlanId', this.planId);

    },

    imageUrl(paymentMethod){
      if(!paymentMethod || !paymentMethod.paymentMethod.imagePath)
        return "";
      return '/static/payment-methods/' + paymentMethod.paymentMethod.imagePath.split('.')[0] + '.svg';
    },
    validateAll(){
      if(!this.contractPaymentMethodId){

        return Promise.reject({customMsg: "Por favor selecione uma forma de pagamento"});

      }
        this.$emit('paymentSelected', this.paymentSelected);
        if(this.paymentSelected.creditCard){
          if(!this.paymentSelected.secureCodeCreditCard || this.paymentSelected.secureCodeCreditCard.length < 3 )
            return Promise.reject({customMsg: "Informe o código de segurança do cartão"});
        }
        this.$emit('cvv', this.paymentSelected.secureCodeCreditCard);
        return Promise.resolve(true);


    },
    getPaymentSelected(){
      if(this.contractPaymentMethodId == -1){
        return {paymentMethod: {paymentMethodId: 12}}
      }
      this.paymentSelected.cvv = this.paymentSelected.secureCodeCreditCard;
      return this.paymentSelected;
    },
    isPaymentMethodAuthorized(shortName) {
      if (!this.taxIdNumber) {
        return true; // Se não tem taxIdNumber, permite (comportamento padrão)
      }

      // Se as autorizações ainda não foram carregadas, permite (comportamento padrão)
      if (!this.paymentMethodsAuthorized || Object.keys(this.paymentMethodsAuthorized).length === 0) {
        return true;
      }

      // Se o shortName não está no mapa de autorizações, permite (comportamento padrão)
      if (!this.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
        return true;
      }

      // Retorna true se authorized === 1 (pode usar), false se authorized === 0 (não pode usar)
      return this.paymentMethodsAuthorized[shortName] === true;
    }

  },
  computed: {
    typesAllowed(){
      return this.$store.getters.getPaymentsTypesByPlan(this.planId);
    },
    taxIdNumber() {
      return Auth.currentUser && Auth.currentUser.taxIdNumber;
    },
    hasValidActivePaymentMethod() {
      // Formas de pagamento que aparecem diretamente
      
      // 1. Cartões cadastrados: aparece se arrayCartao tem itens e CC está autorizado
      const hasRegisteredCreditCards = this.arrayCartao &&
        this.arrayCartao.length > 0 &&
        this.isPaymentMethodAuthorized('CC');

      // 2. Débitos em conta cadastrados: aparece se arrayDebito tem itens e DC está autorizado
      const hasRegisteredDebits = this.arrayDebito &&
        this.arrayDebito.length > 0 &&
        this.isPaymentMethodAuthorized('DC');

      // 3. Boleto: aparece se boletoCadastrato existe ou bankBillOption existe e BC está autorizado
      const hasBankBill = (this.boletoCadastrato || this.bankBillOption) &&
        this.isPaymentMethodAuthorized('BC');

      // 4. Nova forma de pagamento: aparece se showNewPayment e há opções disponíveis
      const hasNewPaymentOption = this.showNewPayment &&
        this.planId != 22 &&
        this.planId != 32 &&
        (this.typesAllowed && (this.typesAllowed.creditCard || this.typesAllowed.bankAccount)) &&
        (this.isPaymentMethodAuthorized('CC') || this.isPaymentMethodAuthorized('DC'));

      // Retorna true se pelo menos uma forma de pagamento está disponível
      return hasRegisteredCreditCards ||
             hasRegisteredDebits ||
             hasBankBill ||
             hasNewPaymentOption;
    }
  },
  components:{
    Payment
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/vehicle/choose-payment.js